import { minutesInHour, secondsInHour } from 'helpers/timeConsts';
import formatMinutes from 'helpers/formatMinutes';
import { ScheduleRange } from 'store/scheduleRanges/interfaces';

interface GetScheduleShiftProps {
  scheduleRanges: ScheduleRange[];
  day: number;
}

const getScheduleShift = ({ scheduleRanges, day }: GetScheduleShiftProps) => {
  const scheduleRange = scheduleRanges.find((range) => range.day === day);

  if (!scheduleRange) {
    return null;
  }

  return {
    timeFrom: {
      hours: Math.floor(scheduleRange.timeFrom / secondsInHour),
      minutes: formatMinutes(
        Math.floor((scheduleRange.timeFrom % secondsInHour) / minutesInHour),
      ),
    },
    timeTo: {
      hours: Math.floor(scheduleRange.timeTo / secondsInHour),
      minutes: formatMinutes(
        Math.floor((scheduleRange.timeTo % secondsInHour) / minutesInHour),
      ),
    },
  };
};

export default getScheduleShift;
